/**
 *  Date    : 2021/03/23
 *  Author  : Sunkery
 *  Declare : table组件
 */
import React, { forwardRef } from 'react';
import { Table } from '@/components/AntD';
import classNames from 'classnames';

import Pagination from '@/components/Pagination';

import { DndContext } from '@dnd-kit/core';
import { SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { CSS } from '@dnd-kit/utilities';

import './Table.scss';

function WtdcAntdTable(props, ref) {

  const {
    /** 拖拽相关属性 */
    /** 完成拖拽事件 */
    onDragEnd,
    /** 允许拖拽 */
    allowDrag,
    /** 出现拖拽的列名 */
    rowKey,
    ...tableProps
  } = props;

  function _onPageChange(index, pageSize) {

    const { onChange } = props;
    // pagination组件的index从1开始，而后端接收的currentPage为0开始
    if(!onChange) return;
    onChange({ pageNum: index, pageSize, currentPage: index - 1, numPerPage: pageSize });
  }
  function _renderPagination() {
    const { pageBean = {}, paginationProps = {}} = props;
    if(!pageBean.numPerPage && !pageBean.pageSize) return;
    return (
      <Pagination
        className={classNames(paginationProps.className)}
        {...paginationProps}
        current={pageBean.pageNum || (pageBean.currentPage + 1)}    // pagination组件current值为1开始，后端接收的currentPage为0开始，新的接口为pageNum，从1开始
        pageSize={pageBean.pageSize || pageBean.numPerPage}
        total={pageBean.total || pageBean.totalCount}
        onChange={_onPageChange}
      />
    );
  }

  // 做选中项的功能
  // 包含头部批量操作
  // 包含记忆功能
  // if(rowSelection) {
  //   // 如果是记忆功能，需要替换两个方法和两个属性
  //   if(rowSelection.memorize) {
  //     return <MemorizeTable {...props} ref={ref} />;
  //   } else {  // 如果是非记忆功能,则使用普通的替代
  //     return <NormalTable {...props} ref={ref} />;
  //   }
  // }

  function onTableDragEnd(e) {
    const activeId = e.active.id;
    const overId = e.over.id;
    onDragEnd && onDragEnd(activeId, overId, e.delta);
    return false;
  }
  return <div className="wtdc-antd-table">
    {allowDrag ? <DndContext onDragEnd={onTableDragEnd} modifiers={[restrictToVerticalAxis]}>
      <SortableContext
        items={props.dataSource.map(item => item.id) || []}
        strategy={verticalListSortingStrategy}
      >
        <Table
          {...tableProps}
          components={{
            body: {
              row: Row
            }
          }}
          rowKey={rowKey}
          pagination={false}
        />
      </SortableContext>
    </DndContext>
    :
    <Table
      {...tableProps}
      rowKey={rowKey}
      pagination={false}
    />}
    { _renderPagination() }
  </div>;
}

export default forwardRef(WtdcAntdTable);

/** 拖拽列表行 */
const Row = (params) => {
  const { children, ...props } = params;
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({
    id: props['data-row-key']
  });
  const style = {
    ...props.style,
    transform: CSS.Transform.toString(transform && {
      ...transform,
      scaleY: 1
    },),
    transition,
    ...(isDragging
      ? {
        position: 'relative'
        //zIndex: 9999
      }
      : {})
  };
  return (
    <tr {...props} ref={setNodeRef} style={style} {...attributes}>
      {React.Children.map(children, (child) => {
        if(child.key === 'sort') {
          const SorBtn = (props) => <span
            ref={setActivatorNodeRef}
            style={{
              touchAction: 'none',
              cursor: 'move'
            }}
            className={props.className}
            {...listeners}
          >{props.children}</span>;
          return React.cloneElement(child, {
            children: (
              <div className="sort-box">
                {child.props.render && child.props.render('', child.props.record, child.props.renderIndex, SorBtn)}
              </div>
            )
          });
        }
        return child;
      })}
    </tr>
  );
};
/**
 * 快速创建一个列
 * @param {*} title 标题
 * @param {*} key 字段名
 * @param {*} params 其他参数
 */
export const setColumn = (title, key, params) => {
  const dataIndex = key;
  let { render } = params || {};
  if(!render) {
    render = value => ((isNaN(value) && !value) ? '--' : value);
  }
  return {
    title, dataIndex, key, render,
    ...(params || {})
  };
};

/**
 * 快速创建操作栏
 * @param {*} render 渲染方法，参数返回本行数据
 * @param {*} title 标题，默认“操作”
 * @param {*} key 字段名，默认“operate”
 * @param {*} params 其他参数
 * @returns
 */
export const setOperate = (render, title = '操作', key = 'operate', params) => {
  const dataIndex = key;
  return {
    title, key, dataIndex,
    render: (value, row) => {
      return render(row);
    },
    ...(params || {})
  };
};
